<template>
    <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
        <v-btn color="primary" text v-on="on">{{text}}</v-btn>
      </template>
        <v-card>
          <v-card-title>
            Reset Password
          </v-card-title>
          <v-card-text>
              <v-form   
                 ref="form"
                v-model="valid">
          <v-text-field
            :rules='emailRules'
            v-model='resetEmail'
            label="Please Enter Your Email Address"
            required
            outline
          ></v-text-field>
            <v-btn :disabled="!valid" color="primary" text @click="resetPassword">Send</v-btn>
           </v-form>
          </v-card-text>
          <v-card-actions>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
export default {
    props : {
        text : String
    },
    data(){
        return{
        resetEmail : null,
        valid : true,
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
        }
    },
    methods :{
            resetPassword(){
                    const url = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key=' + process.env.VUE_APP_ROOT_API_KEY
                    const options = {"requestType":"PASSWORD_RESET","email":this.resetEmail}
                    this.$axios
                .post(url,options)
                .then( () => {
                    this.snackBarType = "success"    
                    this.snackBarshow =true; 
                    this.snackBarmessage = "Password reset email sent, please check your email for resetting instruction";
                    this.resetEmail = "";
                    this.dialog2 = false})
                .catch( () => {
                    this.snackBarType = "warning"    
                    this.snackBarshow =true; 
                    this.snackBarmessage = "Error";
                })
                },
    },
       computed : {
    ...mapFields([
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    },
    
}
</script>